import {
    browserName,
    browserVersion,
    deviceType,
    engineName,
    engineVersion,
    fullBrowserVersion,
    isAndroid,
    isChrome,
    isChromium,
    isEdge,
    isFirefox,
    isIOS,
    isMacOs,
    isMobile,
    isSafari,
    isWindows,
    osName,
    osVersion
} from 'react-device-detect';

import { DeviceInformationState } from '@core/types';

export const useDeviceInfo = (): DeviceInformationState => ({
    isMobile,
    deviceType,
    browserInformation: {
        browserName: browserName,
        browserVersion: browserVersion,
        fullBrowserVersion: fullBrowserVersion,
        engineName: engineName,
        engineVersion: engineVersion,
        isEdge: isEdge,
        isSafari: isSafari,
        isFirefox: isFirefox,
        isChrome: isChrome,
        isChromium: isChromium
    },
    operatingSystemInformation: {
        isWindows: isWindows,
        isAndroid: isAndroid,
        isMacOs: isMacOs,
        osName: osName,
        osVersion: osVersion,
        isIOS: isIOS
    }
});
